class ImageHotspot extends HTMLElement {
  constructor() {
    super();
    this.hotspots = this.querySelectorAll('.hotspot');
    this.activeHotspot = null;
    this.init();
  }

  init() {
    // Add click events for mobile
    this.hotspots.forEach(hotspot => {
      const button = hotspot.querySelector('.hotspot__button');
      
      button.addEventListener('click', (e) => {
        e.stopPropagation();
        this.toggleHotspot(hotspot);
      });

      // Close tooltip when clicking on links inside tooltip
      const links = hotspot.querySelectorAll('a');
      links.forEach(link => {
        link.addEventListener('click', (e) => {
          e.stopPropagation();
        });
      });
    });

    // Close tooltips when clicking outside
    document.addEventListener('click', () => {
      this.closeAllTooltips();
    });

    // Close on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closeAllTooltips();
      }
    });

    // Handle resize
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  toggleHotspot(hotspot) {
    const isActive = hotspot === this.activeHotspot;
    
    this.closeAllTooltips();
    
    if (!isActive) {
      hotspot.classList.add('active');
      this.activeHotspot = hotspot;
      
      // For touch devices, add overlay
      if (this.isTouchDevice()) {
        this.createOverlay();
      }
    }
  }

  closeAllTooltips() {
    this.hotspots.forEach(hotspot => {
      hotspot.classList.remove('active');
    });
    this.activeHotspot = null;
    this.removeOverlay();
  }

  createOverlay() {
    if (!this.overlay) {
      this.overlay = document.createElement('div');
      this.overlay.className = 'hotspot-overlay';
      this.overlay.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        z-index: 99;
      `;
      this.overlay.addEventListener('click', () => {
        this.closeAllTooltips();
      });
      document.body.appendChild(this.overlay);
      document.body.style.overflow = 'hidden';
    }
  }

  removeOverlay() {
    if (this.overlay) {
      this.overlay.remove();
      this.overlay = null;
      document.body.style.overflow = '';
    }
  }

  isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  }

  handleResize() {
    // Close tooltips on resize
    this.closeAllTooltips();
  }

  disconnectedCallback() {
    this.removeOverlay();
  }
}

// Initialize all image hotspot sections
if (!customElements.get('image-hotspot-section')) {
  customElements.define('image-hotspot-section', ImageHotspot);
}

// Auto-initialize existing sections
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.image-hotspot-section').forEach(section => {
    new ImageHotspot(section);
  });
});

// Initialize sections added dynamically
if (typeof Shopify !== 'undefined') {
  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector('.image-hotspot-section');
    if (section) {
      new ImageHotspot(section);
    }
  });
}